import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";

import { OnboardingPreviewProvider } from "@/features/Onboarding/components/OnboardingPreviewProvider";

// Layout above the step route: the preview model it provides survives step
// changes (each $stepId is its own match and remounts).
export const Route = createFileRoute("/_auth/brand-onboarding/$siteId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = useParams({ from: "/_auth/brand-onboarding/$siteId" });
  return (
    // Keyed by site: another site is another brand book and another model.
    <OnboardingPreviewProvider key={siteId} siteId={siteId}>
      <Outlet />
    </OnboardingPreviewProvider>
  );
}
